import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import saleImg from "../../../assets/images/saleImg.png";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { RiDeleteBinLine } from "react-icons/ri";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

export const StateSales = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [cartOrdersList, setCartOrdersList] = useState([]);
  async function LoadOrdersList() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/pos/distributor/draft-list/");
      if (response.data.status === "Success" || response.status === 200) {
        setCartOrdersList(response.data?.draft_orders);
        console.log("Orders list fetched successfully!");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch orders list");
      console.log("Failed to fetch orders list");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    LoadOrdersList();
  }, []);
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="salesContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle"> Sales (POS)</div>
              <div className="inventorySubtitle">
                Create new sales bills for walk-in customers or retail buyers.
              </div>
            </div>
            <div className="addButtonContainer">
              <div className="inventoryBtnReorder">
                <button onClick={() => navigate("/state-sales-products")}>
                  Add Products
                </button>
              </div>
            </div>
          </div>

          {/* card orders list  */}
          {cartOrdersList.length > 0 ? (
            <div className="salescartOrderGrid">
              {cartOrdersList.map((order) => (
                <div key={order.order_id} className="salescartOrderCard">
                  <div className="salesOrderText">
                    <span>Order Id : </span>
                    <span> {order.order_id}</span>
                  </div>
                  <div className="salesOrderText">
                    <span>Order Date : </span>
                    <span>{order.order_date}</span>
                  </div>
                  <div className="salesOrderText">
                    <span>Total Amount : </span>
                    <span> {order.total_amount}</span>
                  </div>
                  <div className="salesBtnResume">
                    <button
                      onClick={() =>
                        navigate("/state-sales-products", {
                          state: { orderId: order.order_id },
                        })
                      }
                    >
                      Resume
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>Data Not available</div>
          )}
        </div>
      </div>
    </>
  );
};
